import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { KeyValueInt, KeyValueSet, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent {
  model: NgbDateStruct;
  @Input() isDisabled = false; @Input() isTop = false; @Input() isReadOnly = true; @Input() isShowClearButton = false;
  @Input() selectedDate: string; @Input() isLoadTodayDate = true; minDate: NgbDateStruct;
  @Input() isOpen: boolean = false; @Input() isTodayMinimumDate: boolean = false;
  @Output() selectedDateChange = new EventEmitter<any>();
  @Output() isOpenChange = new EventEmitter<any>();
  months: KeyValueSet[] = []; selectedMonth = '';
  years: KeyValueSet[] = []; selectedYear = '';
  htmlId: string = ''; elementIds: any;

  constructor(private calendar: NgbCalendar, public localService: LocalService) {
    //this.onLoadMonths();
    this.htmlId = this.localService.getRandomString(5);
    this.onLoad();
  }

  ngOnChanges() {
    this.onLoad();
  }

  onLoad() {
    if (this.isTodayMinimumDate) {
      const today = new Date();
      this.minDate = {
        year: today.getFullYear(),
        month: today.getMonth() + 1, // JS months are 0-based
        day: today.getDate()
      };
    }
    if (this.selectedDate && this.selectedDate != '' && this) {
      let dts = this.selectedDate.split('-');
      this.selectedYear = dts[2];
      this.selectedMonth = parseInt(dts[1]).toString();
      this.model = {
        year: parseInt(this.selectedYear),
        month: parseInt(this.selectedMonth),
        day: parseInt(dts[0])
      }
      //this.onLoadYears();
    } else if (this.isLoadTodayDate) {
      this.selectToday();
    }
  }

  selectToday() {
    this.model = this.calendar.getToday();
    this.selectedYear = this.model.year.toString();
    this.selectedMonth = this.model.month.toString();
    //this.onLoadYears();
  }

  onAction(index, value = '') {
    switch (index) {
      case 1: {
        this.isOpen = !this.isOpen;
        if (this.model) {
          this.selectedMonth = this.model.month.toString();
          this.selectedYear = this.model.year.toString();
          this.selectedDate = [this.model.day, this.model.month, this.model.year].join('-');
        } else {
          this.selectedDate = '';
        }
        //this.onLoadYears();
        this.selectedDateChange.emit(this.selectedDate);
        this.isOpenChange.emit(this.isOpen);
      } break;
      case 2: {
        this.onCalenderButtonClick();
        this.model = {
          day: 1,
          month: parseInt(value),
          year: parseInt(this.selectedYear)
        }
        this.onCalenderButtonClick(true);
      } break;
      case 3: {
        this.onCalenderButtonClick();
        this.model = {
          day: 1,
          month: parseInt(this.selectedMonth),
          year: parseInt(value)
        }
        this.onCalenderButtonClick(true);
        //this.onLoadYears();
      } break;
      case 4: {
        this.model = null;
        this.selectedDate = '';
        this.selectedDateChange.emit(this.selectedDate);
      } break;
    }
  }

  onCalenderButtonClick(isTimeDelay = false) {
    setTimeout(() => {
      let menu = document.getElementById('btn_date_picker_' + this.htmlId) as HTMLElement;
      menu.click();
    }, isTimeDelay ? 10 : 0);
  }

  onLoadMonths() {
    this.months.push({ key: "1", value: "Jan" } as KeyValueSet);
    this.months.push({ key: "2", value: "Feb" } as KeyValueSet);
    this.months.push({ key: "3", value: "Mar" } as KeyValueSet);
    this.months.push({ key: "4", value: "Apr" } as KeyValueSet);
    this.months.push({ key: "5", value: "May" } as KeyValueSet);
    this.months.push({ key: "6", value: "Jun" } as KeyValueSet);
    this.months.push({ key: "7", value: "Jul" } as KeyValueSet);
    this.months.push({ key: "8", value: "Aug" } as KeyValueSet);
    this.months.push({ key: "9", value: "Sep" } as KeyValueSet);
    this.months.push({ key: "10", value: "Oct" } as KeyValueSet);
    this.months.push({ key: "11", value: "Nov" } as KeyValueSet);
    this.months.push({ key: "12", value: "Dec" } as KeyValueSet);
  }

  onLoadYears() {
    let currentYear = (this.selectedYear && this.selectedYear != '' ? parseInt(this.selectedYear) : this.calendar.getToday().year) - 10;
    this.years = null;
    this.years = [] as KeyValueSet[];
    for (var i = 0; i <= 20; i++) {
      let year = currentYear + i;
      this.years.push({ key: year.toString(), value: year.toString() } as KeyValueSet);
    }
  }

}

